import doublePicture1 from './../assets/images/Double/picture1.webp'
import doublePicture2 from './../assets/images/Double/picture2.webp'
import doublePicture3 from './../assets/images/Double/picture3.webp'
import doublePicture4 from './../assets/images/Double/picture4.webp'
import kingPicture1 from './../assets/images/King/picture1.jpg'
import kingPicture2 from './../assets/images/King/picture2.jpg'
import kingPicture3 from './../assets/images/King/picture3.jpg'
import kingPicture4 from './../assets/images/King/picture4.webp'
import triplePicture1 from './../assets/images/Triple/picture1.jpg'
import triplePicture2 from './../assets/images/Triple/picture2.webp'
import triplePicture3 from './../assets/images/Triple/picture3.jpg'
import triplePicture4 from './../assets/images/Triple/picture4.jpg'
import familyPicture1 from './../assets/images/Family/picture1.webp'
import familyPicture2 from './../assets/images/Family/picture2.jpg'
import familyPicture3 from './../assets/images/Family/picture3.jpg'
import familyPicture4 from './../assets/images/Family/picture4.webp'

const RoomOverviews = () => {
  const rooms = [
    {
      name: "Super King", 
      description:
        "These rooms capture the delightful character of the building whilst incorporating an opulent and modern twist.",
      images: [
        kingPicture1,
        kingPicture2,
        kingPicture3,
        kingPicture4,
      ],
      features: [
        { name: "Occupancy", description: "Sleeps 2" },
        { name: "Bed", description: "1 King Size Bed" },
        { name: "Amenities", description: "Free WiFi, Television, Iron/Ironing Board, Toiletries, Hairdryer, Towels, Shower, Tea/Coffee Machine" },
        { name: "Breakfast", description: "Included with Room" },
        { name: "Rate", description: "£ 90 per night" },
      ],
      link : "https://direct-book.com/properties/thefoxidirect?locale=en&items[0][adults]=2&items[0][children]=0&items[0][infants]=0&items[0][rateId]=589662&currency=GBP&checkInDate=2025-01-31&checkOutDate=2025-02-01&trackPage=no&selected=0"
    },
    {
      name: "Twin/Double",
      description:
        "Perfect for friends or couples, offering flexibility with twin or double bed configurations.",
      images: [
        doublePicture1,
        doublePicture2,
        doublePicture3,
        doublePicture4,
      ],
      features: [
        { name: "Occupancy", description: "Sleeps 2" },
        { name: "Bed", description: "1 Double Bed or 2 Single Beds" },
        { name: "Amenities", description: "Free WiFi, Television, Iron/Ironing Board, Toiletries, Hairdryer, Towels, Shower, Tea/Coffee Machine" },
        { name: "Breakfast", description: "Included with Room" },
        { name: "Rate", description: "£ 90 per night" },
      ],
      link : "https://direct-book.com/properties/thefoxidirect?locale=en&items[0][adults]=2&items[0][children]=0&items[0][infants]=0&items[0][rateId]=590545&currency=GBP&checkInDate=2025-01-31&checkOutDate=2025-02-01&trackPage=no&selected=0"
    },
    {
      name: "Triple",
      description:
        "Ideal for small groups or families, featuring ample space and comfortable bedding options.",
      images: [
        triplePicture1,
        triplePicture2,
        triplePicture3,
        triplePicture4
      ],
      features: [
        { name: "Occupancy", description: "Sleeps 3" },
        { name: "Bed", description: "1 Double Bed and 1 Single Bed" },
        { name: "Amenities", description: "Garden View, Free WiFi, Television, Iron/Ironing Board, Toiletries, Hairdryer, Towels, Shower, Tea/Coffee Machine" },
        { name: "Breakfast", description: "Included with Room" },
        { name: "Rate", description: "£ 110 per night" },
      ],
      link : "https://direct-book.com/properties/thefoxidirect?locale=en&items[0][adults]=3&items[0][children]=0&items[0][infants]=0&items[0][rateId]=590548&currency=GBP&checkInDate=2025-01-31&checkOutDate=2025-02-01&trackPage=no&selected=0"
    },
    {
      name: "Family Room",
      description:
        "Spacious and comfortable, perfect for families looking for a relaxing stay.",
      images: [
        familyPicture1,
        familyPicture2,
        familyPicture3,
        familyPicture4
      ],
      features: [
        { name: "Occupancy", description: "Sleeps 4" },
        { name: "Bed", description: "1 Double Bed and 2 Single Beds" },
        { name: "Amenities", description: "Free WiFi, Television, Iron/Ironing Board, Toiletries, Hairdryer, Towels, Shower, Tea/Coffee Machine" },
        { name: "Breakfast", description: "Included with Room" },
        { name: "Rate", description: "£ 160 per night" },
      ],
      link : "https://direct-book.com/properties/thefoxidirect?locale=en&items[0][adults]=2&items[0][children]=2&items[0][infants]=0&items[0][rateId]=589661&currency=GBP&checkInDate=2025-01-31&checkOutDate=2025-02-01&trackPage=no&selected=0"
    },
  ];

  return (
    <div className='lg:pt-32 pb-16 bg-gray-50'>
      <div>
        {rooms.map((room, index) => (
          <div
            key={room.name}
            className="mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2 items-center gap-12 px-6 lg:px-12 py-16 bg-white shadow-lg rounded-2xl overflow-hidden mb-12"
          >
            {index % 2 === 0 ? (
              <>
                <div className="p-6 lg:p-12">
                  <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
                    {room.name}
                  </h2>
                  <p className="mt-6 text-lg text-gray-600 leading-relaxed">
                    {room.description}
                  </p>
                  <dl className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
                    {room.features.map((feature) => (
                      <div key={feature.name} className="border-l-4 border-blue-500 pl-4">
                        <dt className="text-lg font-medium text-gray-900">{feature.name}</dt>
                        <dd className="mt-1 text-gray-600">{feature.description}</dd>
                      </div>
                    ))}
                    <div className="border-l-4 border-blue-500 pl-4 flex">
                      <a className='flex' href={room.link}>
                        <button className='bg-gray-700 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition duration-300 shadow-md'>Reserve Now</button>
                      </a>
                    </div>
                  </dl>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  {room.images.map((img, i) => (
                    <img key={i} src={img} alt={room.name} className="rounded-lg shadow-md hover:scale-105 transition-transform duration-300" />
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="grid grid-cols-2 gap-4">
                  {room.images.map((img, i) => (
                    <img key={i} src={img} alt={room.name} className="rounded-lg shadow-md hover:scale-105 transition-transform duration-300" />
                  ))}
                </div>
                <div className="p-6 lg:p-12">
                  <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
                    {room.name}
                  </h2>
                  <p className="mt-6 text-lg text-gray-600 leading-relaxed">
                    {room.description}
                  </p>
                  <dl className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
                    {room.features.map((feature) => (
                      <div key={feature.name} className="border-l-4 border-blue-500 pl-4">
                        <dt className="text-lg font-medium text-gray-900">{feature.name}</dt>
                        <dd className="mt-1 text-gray-600">{feature.description}</dd>
                      </div>
                    ))}
                    <div className="border-l-4 border-blue-500 pl-4 flex">
                      <a className='flex' href={room.link}>
                        <button className='bg-gray-700 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition duration-300 shadow-md'>Reserve Now</button>
                      </a>
                    </div>
                  </dl>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoomOverviews;
